export default __webpack_public_path__ + "static/4Oxygen-Home-Loans-Broker-Info-Final-320a6e57906bba4d35b438761fb1807c.pdf";